import { MERGEABLE_TARGET_STATUSES, OrderStatus } from "@/models/Order";

export interface DuplicateDecision {
    allowDuplicate: boolean;
    mergeTargetId: number | null;
}

interface MergeCandidate {
    id?: number | string;
    status?: OrderStatus;
}

// Presence alone is not enough: getOpenOrders still returns statuses MergeOrders rejects.
export function findMergeableTarget<T extends MergeCandidate>(openOrders: T[], mergeTargetId: number): T | null {
    const target = openOrders.find(o => Number(o.id) === mergeTargetId);
    if (!target || target.status == null) return null;
    return MERGEABLE_TARGET_STATUSES.includes(target.status) ? target : null;
}

/** Builds the query string an order/scripts POST needs to reflect a duplicate-order decision. */
export function buildDuplicateOrderQuery(baseUrl: string, decision: DuplicateDecision | null): string {
    const query: string[] = [];
    if (decision?.allowDuplicate) query.push('allowDuplicate=true');
    if (decision?.mergeTargetId != null) query.push('mergeIntent=true');
    return query.length ? `${baseUrl}?${query.join('&')}` : baseUrl;
}
